var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85002 12.8266L8.00002 10.9266L11.15 12.8516L10.325 9.25159L13.1 6.85159L9.45002 6.52659L8.00002 3.12659L6.55002 6.50159L2.90002 6.82659L5.67502 9.25159L4.85002 12.8266ZM3.32502 14.9246L4.56502 9.61159L0.442017 6.03959L5.87302 5.56959L8.00002 0.558594L10.127 5.56859L15.557 6.03859L11.435 9.61059L12.675 14.9236L8.00002 12.1036L3.32502 14.9246Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.9c4ddb9a64c86a00cd259e60aadfaccf.svg";
export { ForwardRef as ReactComponent };